import { useQuery } from "@tanstack/react-query";

import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { ThuisbezorgdSettingData } from "@/shared/utils/interfaces";

const useThuisbezorgdQuery = () => {
  const branch = useBranchId();

  const query = useQuery<ThuisbezorgdSettingData>({
    queryKey: ["thuisbezorgd", branch],
    queryFn: () => get2(`internal/secure/pos/v2/takeaway/settings/${branch}`),
  });

  return { ...query };
};

export default useThuisbezorgdQuery;
